const SUPPORT_LINKS = {
  'AR': 'https://climate.com/es-ar/centro-de-ayuda.html',
  'BR': 'https://climate.com/pt-br/ajuda-rapida.html',
  'CA': 'https://support.climatefieldview.ca',
  'DE': 'https://support.climate.com/kt#/de_DE',
  'ES': 'https://support.climate.com/kt#/es_ES',
  'FR': 'https://support.climate.com/kt#/fr_FR',
  'HU': 'https://support.climate.com/kt#/hu_HU',
  'IT': 'https://support.climate.com/kt#/it_IT',
  'PL': 'https://support.climate.com/kt#/pl_PL',
  'RO': 'https://support.climate.com/kt#/ro_RO',
  'UA': 'https://support.climate.com/kt#/uk_UA',
  'US': 'https://support.climate.com',
  'default': 'https://support.climate.com'
};

export const getSupportUrl = (countryCode?: string) => {
  if (countryCode && countryCode in SUPPORT_LINKS) {
    return SUPPORT_LINKS[countryCode as keyof typeof SUPPORT_LINKS];
  }

  return SUPPORT_LINKS.default;
};
